module.exports = __webpack_public_path__ + "static/media/heroBack8.8dbe0980.svg";